import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxTileComponent } from './phx-tile.component';

@NgModule({
  declarations: [PhxTileComponent],
  imports: [CommonModule],
  exports: [PhxTileComponent],
})
export class PhxTileModule {}
